import { render, staticRenderFns } from "./ButtonCadu.vue?vue&type=template&id=6edbb8d0&scoped=true"
import script from "./ButtonCadu.vue?vue&type=script&lang=js"
export * from "./ButtonCadu.vue?vue&type=script&lang=js"
import style0 from "./ButtonCadu.vue?vue&type=style&index=0&id=6edbb8d0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edbb8d0",
  null
  
)

export default component.exports